import React from "react";

import CheckboxFilters from "./CheckboxFilters";
import TileFilters from "./TileFilters";
import ToggleFilter from "./ToggleFilter";
import {
  AvailableFilter,
  FilterType,
  GroupFilter,
  ToggleFilterType,
} from "./types";

export const DEFAULT_VISIBLE_TAKE = 9;

export type NoFollowLinkProp = (href: {
  pathname: string | null;
  query: string;
}) => boolean;

export type FilterQueryStringKeyProp = (filterName: string) => string;

const DynamicFilters: React.FC<{
  availableFilters: AvailableFilter[];
  defaultOpenKey?: string;
  sectionPadding?: string;
  noFollowLink?: NoFollowLinkProp;
  includeFilterEvents?: boolean;
  eventCategory?: string;
  filterQueryStringKey?: FilterQueryStringKeyProp;
}> = ({
  availableFilters,
  defaultOpenKey,
  sectionPadding,
  noFollowLink,
  includeFilterEvents,
  eventCategory,
  filterQueryStringKey,
}) => {
  return (
    <>
      {availableFilters.map((filter) => (
        <DynamicFilter
          key={filter.name}
          filter={filter}
          defaultOpenKey={defaultOpenKey}
          sectionPadding={sectionPadding}
          noFollowLink={noFollowLink}
          includeFilterEvents={includeFilterEvents}
          eventCategory={eventCategory}
          filterCategory={filter.label}
          filterQueryStringKey={filterQueryStringKey}
        />
      ))}
    </>
  );
};

export const DynamicFilter: React.FC<{
  filter: AvailableFilter;
  defaultOpenKey?: string;
  openSection?: string;
  sectionPadding?: string;
  noFollowLink?: NoFollowLinkProp;
  includeFilterEvents?: boolean;
  eventCategory?: string;
  filterCategory?: string;
  filterQueryStringKey?: FilterQueryStringKeyProp;
}> = ({
  filter,
  defaultOpenKey,
  sectionPadding,
  noFollowLink,
  includeFilterEvents,
  eventCategory,
  filterCategory,
  filterQueryStringKey,
}) => (
  <>
    {filter.type === FilterType.toggle && (
      <ToggleFilter
        filter={filter as ToggleFilterType}
        sectionPadding={sectionPadding}
        noFollowLink={noFollowLink}
        includeFilterEvents={includeFilterEvents}
        eventCategory={eventCategory}
        filterQueryStringKey={filterQueryStringKey}
      />
    )}
    {filter.type === FilterType.tileGroup &&
      (filter as GroupFilter).values.length > 0 && (
        <TileFilters
          filter={filter as GroupFilter}
          defaultOpenKey={defaultOpenKey}
          sectionPadding={sectionPadding}
          noFollowLink={noFollowLink}
          filterQueryStringKey={filterQueryStringKey}
        />
      )}
    {filter.type === FilterType.checkBoxGroup &&
      (filter as GroupFilter).values.length > 0 && (
        <CheckboxFilters
          filter={filter as GroupFilter}
          defaultOpenKey={defaultOpenKey}
          sectionPadding={sectionPadding}
          noFollowLink={noFollowLink}
          includeFilterEvents={includeFilterEvents}
          eventCategory={eventCategory}
          filterCategory={filterCategory}
          filterQueryStringKey={filterQueryStringKey}
        />
      )}
  </>
);

export default DynamicFilters;
